import { render, staticRenderFns } from "./Orthomosaic.vue?vue&type=template&id=2ee8c58d&"
import script from "./Orthomosaic.vue?vue&type=script&lang=js&"
export * from "./Orthomosaic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports